import React, { Component } from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';

class Table extends Component {
    render() {
        if (this.props.data.length === 0)
            return (
                <div>
                    <div className="text-center">{this.props.renderEmpty()}</div>
                </div>
            )

        return (
            <ReactTable
                style={{
                    height: '100%',
                }}
                className="table table-hover"
                {...this.props}
                    defaultPageSize={10}
                />
        )
    }
}


Table.defaultProps = {
    data: [],
    columns: [],
    renderEmpty() { return null }
}

export default Table;


// WEBPACK FOOTER //
// ./src/components/Table.js